import { Button, Checkbox } from 'antd'
import React, { useEffect, useState } from 'react'
import { APIFunctions } from '../../lib/apiFunctions'
import { SyncOutlined } from '@ant-design/icons'
import { ComplianceReport, IReportDataDate } from './types'
import TextArea from 'antd/lib/input/TextArea'

export default function UserNote({
    note_content,
    apiFunctions,
    userId,
    record,
    setDataHasChanged,
    reportMeta,
    fromReport = false,
}: {
    fromReport?: boolean
    note_content: string
    apiFunctions: APIFunctions
    userId: string
    record: IReportDataDate
    setDataHasChanged: (nv: boolean) => void
    reportMeta: ComplianceReport
}) {
    const [content, setContent] = useState<string>(note_content)
    const [changeContent, setChangeContent] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [includeReport, setIncludeReport] = useState<boolean>(true)

    useEffect(() => {
        if (!note_content) return
        setIncludeReport(record.user_note_include_report)
    }, [record, note_content])

    const LoadingComp = <SyncOutlined style={{ fontSize: 10 }} spin />

    const onTextClick = () => {
        if (reportMeta.is_locked) return
        setChangeContent(!changeContent)
    }

    async function saveText(newValue) {
        if (reportMeta.is_locked) return
        setLoading(true)
        setChangeContent(false)
        await apiFunctions.updateUserNote(userId, record.date, {
            content: newValue.target.value,
            include_report: includeReport,
        })
        setLoading(false)
    }

    async function deleteNote() {
        if (reportMeta.is_locked) return
        setLoading(true)
        setChangeContent(false)
        setContent(null)
        await apiFunctions.deleteUserNote(userId, record.date)
        setLoading(false)
    }

    const reportStyle = { display: 'inline-grid', gridTemplateColumns: '4fr 1fr 1fr 2fr' }

    return (
        <>
            {(!changeContent && (
                <h4
                    onClick={onTextClick}
                    style={{
                        opacity: content && content.length > 0 && includeReport ? 1 : 0.2,
                    }}
                >
                    {(content && content.length > 0) || reportMeta.is_locked
                        ? (record.user_note_include_report || !reportMeta.is_locked) ? content : ''
                        : 'Click to add note'}
                </h4>
            )) || (
                <div style={fromReport ? reportStyle : {}}>
                    <TextArea
                        autoFocus
                        placeholder="Click to change"
                        value={content}
                        onChange={(v) => {
                            setContent(v.target.value)
                        }}
                        onPressEnter={saveText}
                        maxLength={200}
                    />
                    <Button onClick={() => saveText({ target: { value: content } })} size="small">
                        save
                    </Button>
                    <Button onClick={deleteNote} size="small">
                        delete
                    </Button>
                    <span>
                        Include{' '}
                        <Checkbox
                            checked={includeReport}
                            onChange={() => setIncludeReport(!includeReport)}
                        />
                    </span>
                </div>
            )}{' '}
            {loading && LoadingComp}
        </>
    )
}
